import { render } from "./modelLoading.vue?vue&type=template&id=74077c63&scoped=true"
import script from "./modelLoading.vue?vue&type=script&lang=js"
export * from "./modelLoading.vue?vue&type=script&lang=js"

import "./modelLoading.vue?vue&type=style&index=0&id=74077c63&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74077c63"],['__file',"src/components/modelLoading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74077c63"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74077c63', __exports__)) {
    api.reload('74077c63', __exports__)
  }
  
  module.hot.accept("./modelLoading.vue?vue&type=template&id=74077c63&scoped=true", () => {
    api.rerender('74077c63', render)
  })

}


export default __exports__